import { twJoin } from "tailwind-merge";

import type { ContainerBreakpoint, ContainerResponsiveValue } from "../contracts/responsive";

export const spaces = ["xs", "sm", "md", "lg", "xl"] as const;
export type Space = (typeof spaces)[number];

const GAP_BASE_CLASSES: Record<Space, string> = {
  xs: "gap-xs",
  sm: "gap-sm",
  md: "gap-md",
  lg: "gap-lg",
  xl: "gap-xl",
};

const GAP_CONTAINER_CLASSES: Record<ContainerBreakpoint, Record<Space, string>> = {
  xs: { xs: "@xs:gap-xs", sm: "@xs:gap-sm", md: "@xs:gap-md", lg: "@xs:gap-lg", xl: "@xs:gap-xl" },
  sm: { xs: "@sm:gap-xs", sm: "@sm:gap-sm", md: "@sm:gap-md", lg: "@sm:gap-lg", xl: "@sm:gap-xl" },
  md: { xs: "@md:gap-xs", sm: "@md:gap-sm", md: "@md:gap-md", lg: "@md:gap-lg", xl: "@md:gap-xl" },
  lg: { xs: "@lg:gap-xs", sm: "@lg:gap-sm", md: "@lg:gap-md", lg: "@lg:gap-lg", xl: "@lg:gap-xl" },
  xl: { xs: "@xl:gap-xs", sm: "@xl:gap-sm", md: "@xl:gap-md", lg: "@xl:gap-lg", xl: "@xl:gap-xl" },
};

export function resolveGapClasses(gap: ContainerResponsiveValue<Space> | undefined): string | undefined {
  if (!gap) {
    return undefined;
  }
  if (typeof gap === "string") {
    return GAP_BASE_CLASSES[gap];
  }

  return twJoin(
    GAP_BASE_CLASSES[gap.base],
    ...Object.entries(gap.container).map(([breakpoint, space]) =>
      space ? GAP_CONTAINER_CLASSES[breakpoint as ContainerBreakpoint][space] : undefined,
    ),
  );
}
